<template>
    <div class="welcome">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "Welcome"
    }
</script>

<style scoped>

</style>